// Third Party Plugins
import React from 'react';
// Types
import { CardContentProps } from './types';
// Utilities
import truncateText from '@utils/truncateText';
// Styles
import { StyledContentContainer, StyledMetaContainer } from './styles';
// Custom Components
import Tag from '@components/tags/Tag';
import BaseButton from '@components/buttons/BaseButton';

const CardContent: React.FC<CardContentProps> = ({
  cardType,
  actionType,
  tagText,
  title,
  isbn,
  publisher,
  author,
  description,
  charLimitTitle,
  charLimitDesc,
}) => {
  return (
    <StyledContentContainer
      style={cardType === 'pastEvent' ? { borderTop: 'none' } : undefined}
    >
      <StyledMetaContainer>
        {author && (
          <span style={{ fontSize: '12px', color: 'grey' }}>
            <strong>author:</strong> {author}
          </span>
        )}
        {isbn && (
          <span style={{ fontSize: '12px', color: 'grey' }}>
            <strong>isbn:</strong> {isbn}
          </span>
        )}
        {publisher && (
          <span style={{ fontSize: '12px', color: 'grey' }}>
            <strong>publisher:</strong> {publisher}
          </span>
        )}
        {tagText && <Tag type="primary" text={tagText} />}
        <h3 title={title}>{truncateText(charLimitTitle, title)}</h3>
        {description && (
          <p title={description}>{truncateText(charLimitDesc, description)}</p>
        )}
      </StyledMetaContainer>
      <BaseButton
        actionType={actionType}
        theme="minor"
        link={actionType === 'link' ? '#' : undefined}
      >
        {cardType === 'resource' ? 'View resource' : 'Learn more'}
      </BaseButton>
    </StyledContentContainer>
  );
};

export default CardContent;
